"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrgAdmins = void 0;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getOrgAdmins = function getOrgAdmins(state) {
  return state.orgAdmin.users;
};

exports.getOrgAdmins = getOrgAdmins;